import { Res } from 'api/api.types';
import { axiosInstance } from 'api/axios';
import { Alert } from './alerts.types';

export const getAlertsCount = async () =>
  await axiosInstance.get<Res<number>>('/alert/count');

export const getAlertsInbox = async () =>
  await axiosInstance.get<Res<Alert[]>>('/alert/inbox');

export const getAlertsPoll = async () =>
  await axiosInstance.get<Res<Alert[]>>('/alert/poll');

export const deleteAlert = async (id: number) =>
  await axiosInstance.delete<Res<null>>(`/alert/${id}`);
